import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {
  public date: any = "";

  ngOnInit() {
    this.date =  new Date().getFullYear();
  }
}



// WEBPACK FOOTER //
// /var/www/portal/bullseye/src/app/components/app-footer/app-footer.component.ts